import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const SavedContext = createContext<{ slugs: string[]; has: (slug: string) => boolean; toggle: (slug: string) => void }>({ slugs: [], has: () => false, toggle: () => undefined });
const key = "neturism:saved-countries:v1";

export function SavedProvider({ children }: { children: React.ReactNode }) {
  const [slugs, setSlugs] = useState<string[]>(() => {
    try { const value = JSON.parse(localStorage.getItem(key) || "[]"); return Array.isArray(value) ? value.filter((v) => typeof v === "string") : []; }
    catch { return []; }
  });
  useEffect(() => { localStorage.setItem(key, JSON.stringify(slugs)); }, [slugs]);
  const toggle = useCallback((slug: string) => setSlugs((items) => items.includes(slug) ? items.filter((item) => item !== slug) : [...items, slug]), []);
  const value = useMemo(() => ({ slugs, has: (slug: string) => slugs.includes(slug), toggle }), [slugs, toggle]);
  return <SavedContext.Provider value={value}>{children}</SavedContext.Provider>;
}

export const useSaved = () => useContext(SavedContext);
